import React, { useState, useEffect } from "react";
import { Input, Select } from "../../../common/commonIndex";

const AddressInformation = ({ nestedQuestion, formData, handleSetData, states, setIsValid, setValidField }) => {
    const [formFields, setFormFields] = useState({
        street: '',
        city: '',
        state: formData.answer.find(item => item?.question?.toLowerCase() === "state" || item?.id === 5646 || item.fkQuestionId === 5646)?.answer || 'Alabama',
        zip: '',
    });

    const [validFields, setValidFields] = useState({
        street: false,
        city: false,
        state: false,
        zip: false,
    });

    const validateField = (value) => typeof value === 'string' && value.trim() !== '';
    const checkFormValidity = () => {
        return Object.values(validFields).every((isValid) => isValid);
    };
    useEffect(() => {
        if (formData && formData?.answer) {
            const initialFields = {
                street: formData?.answer?.find(item => item?.question?.toLowerCase() === "street" || item?.id === 5644 || item.fkQuestionId === 5644)?.answer || '',
                city: formData?.answer?.find(item => item?.question?.toLowerCase() === "city" || item?.id === 5645 || item.fkQuestionId === 5645)?.answer || '',
                state: formData?.answer?.find(item => item?.question?.toLowerCase() === "state" || item?.id === 5646 || item.fkQuestionId === 5646)?.answer || 'Alabama',
                zip: formData?.answer?.find(item => item?.question?.toLowerCase() === "zip" || item?.id === 5647 || item.fkQuestionId === 5647)?.answer || '',
            };

            setFormFields(initialFields);

            setValidFields({
                street: validateField(initialFields.street),
                city: validateField(initialFields.city),
                state: validateField(initialFields.state),
                zip: validateField(initialFields.zip),
            });
            setValidField({
                street: validateField(initialFields.street),
                city: validateField(initialFields.city),
                state: validateField(initialFields.state),
                zip: validateField(initialFields.zip),
            });

        }
    }, [formData]);

    const handleFieldChange = (field, value) => {
        setFormFields((prev) => ({ ...prev, [field]: value }));
        setValidFields((prev) => ({ ...prev, [field]: validateField(value) }));
        setValidField((prev) => ({ ...prev, [field]: validateField(value) }));
        if (formData) {
            // Ensure the question format matches
            const formattedQuestion = field.charAt(0).toUpperCase() + field.slice(1);
            
            // Find the existing answer for the field
            const existingAnswerIndex = formData?.answer?.findIndex(item => item.question === formattedQuestion);
            
            if (existingAnswerIndex !== -1) {
                // If an existing answer is found, update it
                const existingAnswer = formData.answer[existingAnswerIndex];
                existingAnswer.fkQuestionId = !existingAnswer?.fkQuestionId ? nestedQuestion.id : existingAnswer.fkQuestionId;
                existingAnswer.answer = value;
                existingAnswer.fkAnswerIds = value;
                existingAnswer.questionerType = nestedQuestion.questionType; // Replace with the relevant type if needed
                existingAnswer.question = nestedQuestion.question;
            } else {
                // If no existing answer is found, add a new answer
                if (!formData?.answer) {
                    formData.answer = [];
                }
                formData?.answer?.push({
                    fkQuestionId: nestedQuestion?.id, // Replace with the relevant ID if needed
                    answer: value,
                    fkAnswerIds: value,
                    questionerType: nestedQuestion.questionType, // Replace with the relevant type if needed
                    question: formattedQuestion,
                });
            }
            // Optionally remove duplicates based on question
            formData.answer = formData.answer.filter((value, index, self) =>
                index === self.findIndex((t) => t.question === value.question)
            );
    
            handleSetData && handleSetData(formData, isFormValid); // Notify parent about updated data
        }
    };
    
    useEffect(() => {
        const findlength = formData?.answer?.filter(x => !x.answer || x.answer === '')?.length === 0;
        setIsValid(findlength);
    }, [handleFieldChange]);

    const renderInputField = (fieldName, label, isZipCode) => (
        <>
            {fieldName === 'state' ? (
                <div className={`selection-content ${validFields[fieldName] !== '' ? 'valid' : ''}`} key={fieldName}>
                    <Select
                        defaultValue={1}
                        list={states || []}
                        value={formFields[fieldName]}
                        className={'bg-transparent'}
                        valueKey="name"
                        nameKey="name"
                        isProfile={true}
                        onChange={(value) => handleFieldChange('state', value)}
                    />
                </div>
            ) : (
                <div className={`input-group mb-3 ${validFields[fieldName] ? 'valid' : ''}`} key={fieldName}>
                    <Input
                        inputType="text"
                        id={fieldName}
                        inputPlaceholder=""
                        className="form-control"
                        required
                        onChange={(e) => handleFieldChange(fieldName, e)}
                        value={formFields[fieldName]}
                        isZipCode={isZipCode}
                    />
                    <label htmlFor={fieldName} className={validFields[fieldName] ? 'is-active active' : 'active'}>
                        {label}
                    </label>
                </div>
            )}
        </>
    );
    const isFormValid = checkFormValidity();
    return (
        <div>
            <form>
                {(() => {
                    const questionType = nestedQuestion?.question?.toLowerCase();
                    switch (questionType) {
                        case 'street':
                            return renderInputField('street', 'Street', false);
                        case 'city':
                            return renderInputField('city', 'City', false);
                        case 'state':
                            return renderInputField('state', 'State', false);
                        case 'zip':
                            return renderInputField('zip', 'Zip', true);
                        default:
                            return null;
                    }
                })()}
            </form>
        </div>
    );
};

export default AddressInformation;
